import React from 'react';
import { getTrimmedString } from '../../utils';
import '../../FiltersBar.css';

const FiltersBarNotification = (props) => {
  let { name } = props.activeFilterSet ?? {};
  return (
    <div className="FiltersBar_SelectedFilter" data-tip={name || ''}>
      {name ? getTrimmedString(name, 28) : 'No filter'}
    </div>
  );
};

export default FiltersBarNotification;
